import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Attachment from '@mui/icons-material/Attachment';
import CircularProgress from '@mui/material/CircularProgress'; // Import for loading indicator
import Typography from '@mui/material/Typography'; // For status messages
import { connect } from "react-redux"; // Assuming you have react-redux setup

class UploadScreen extends React.Component {
    constructor(props) {
        super(props);
        this.onTextChanged = this.onTextChanged.bind(this);
        this.onFileChanged = this.onFileChanged.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleOpenFileDialog = this.handleOpenFileDialog.bind(this);
        this.fileInputRef = React.createRef();
        this.state = {
            textInput: '',
            selectedFile: null,
            fileName: '',
            isUploading: false,
            uploadStatus: null,
        };
    }

    onTextChanged(event) {
        this.setState({ textInput: event.target.value });
        if (this.props.onTextChange) {
            this.props.onTextChange(event.target.value);
        }
    }

    onFileChanged(event) {
        const file = event.target.files[0];
        if (file) {
            this.setState({ selectedFile: file, fileName: file.name, uploadStatus: null });
            if (this.props.onFileChange) {
                this.props.onFileChange(file);
            }
        } else {
            this.setState({ selectedFile: null, fileName: '', uploadStatus: null });
            if (this.props.onFileChange) {
                this.props.onFileChange(null);
            }
        }
    }

    handleOpenFileDialog = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = null;
        }
        this.fileInputRef.current.click();
    };

    async handleUpload() {
        const { selectedFile, textInput } = this.state;
        // const { username } = this.props; // Uncomment if you need username from Redux props

        if (!selectedFile && !textInput.trim()) {
            this.setState({ uploadStatus: 'Please enter text or select a file to upload.' });
            return;
        }

        this.setState({ isUploading: true, uploadStatus: null });

        const formData = new FormData();

        if (selectedFile) {
            formData.append('file', selectedFile, selectedFile.name); // Key 'file' must match backend expectation
        }
        if (textInput.trim()) {
            formData.append('textData', textInput); // Key 'textData' must match backend expectation
        }
        // if (username) { // Uncomment if sending username
        //     formData.append('username', username);
        // }

        // --- IMPORTANT: Replace with your actual server endpoint ---
        const uploadEndpoint = '/api/your-upload-endpoint';

        try {
            const response = await fetch(uploadEndpoint, {
                method: 'POST',
                body: formData,
                // No 'Content-Type' header needed here for FormData; browser sets it.
                // headers: { // Add other headers like Authorization if required
                //   'Authorization': 'Bearer YOUR_TOKEN',
                // },
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${errorText}`);
            }

            const result = await response.json(); // Assuming JSON response on success

            this.setState({
                isUploading: false,
                uploadStatus: 'Upload successful!',
                // Optionally clear form:
                // textInput: '',
                // selectedFile: null,
                // fileName: ''
            });

        } catch (error) {
            // ignore
            this.setState({
                isUploading: false,
                uploadStatus: `Upload failed: ${error.message}`,
            });
        }
    }

    render() {
        // ----- THE FIX IS HERE -----
        // Added 'selectedFile' to the destructuring assignment below
        const { textInput, fileName, isUploading, uploadStatus, selectedFile } = this.state;

        return (
            <div style={style}>
                <h2>Enter Text and/or Pick File</h2>
                <Paper variant="outlined" style={{ minWidth: 300, padding: 20 }}>
                    <TextField
                        id="outlined-multiline-flexible"
                        label="Enter Text"
                        multiline
                        maxRows={4} // Changed from rowsMax to maxRows if using MUI v5+ (check your version)
                        value={textInput}
                        onChange={this.onTextChanged}
                        variant="outlined"
                        style={{ marginBottom: 16, width: '100%' }}
                        disabled={isUploading}
                    />

                    <div>
                        <input
                            type="file"
                            style={{ display: 'none' }}
                            onChange={this.onFileChanged}
                            ref={this.fileInputRef}
                            disabled={isUploading}
                        />
                        <Button
                            variant="contained"
                            color="inherit"
                            onClick={this.handleOpenFileDialog}
                            startIcon={<Attachment />}
                            style={{ marginRight: 16 }}
                            disabled={isUploading}
                        >
                            Pick File
                        </Button>
                        <span style={{ wordBreak: 'break-all' }}>{fileName || 'No file selected'}</span>
                    </div>

                    {/* --- Upload Button and Status --- */}
                    <div style={{ marginTop: 20, textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleUpload}
                            // Now 'selectedFile' used here is correctly defined from the state destructuring above
                            disabled={isUploading || (!selectedFile && !textInput.trim())}
                            style={{ minWidth: 100 }}
                        >
                            {isUploading ? <CircularProgress size={24} color="inherit" /> : 'Upload'}
                        </Button>
                        {uploadStatus && (
                            <Typography
                                color={uploadStatus.startsWith('Upload failed') ? 'error' : 'primary'}
                                style={{ marginTop: 10 }}
                            >
                                {uploadStatus}
                            </Typography>
                        )}
                    </div>
                </Paper>
            </div>
        );
    }
}

const style = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
};

// Assuming your Redux state has a 'session' slice with 'userId'
const mapStateToProps = ({ session }) => ({
    username: session.userId, // Make sure 'session' and 'userId' match your Redux store structure
});

// If you don't use Redux or don't need the username prop, you can simplify the export:
// export default UploadScreen;
// Otherwise, connect it:
export default connect(mapStateToProps)(UploadScreen);